import http from './http-util'
import config from '../../../config'

class BasisConfirmationServiceApi {
  static sendBasisConfirmation = body => token => {
    return http.post(
      token,
      `${config.basisConfirmationServiceUrl}/confirmations`,
      JSON.stringify(body),
    )
  }

  static fetchConfirmationPdf = body => token => {
    return http.postForBlob(
      token,
      `${config.basisConfirmationServiceUrl}/confirmations/pdf`,
      'application/pdf,application/json',
      JSON.stringify(body),
    )
  }
}

export default BasisConfirmationServiceApi
